import React from 'react'

import { Box, Grid } from '@mui/material'

import ResponsiveAppBar from '~/components/AppBar'
import { useClasses } from '~/themes'

import style from './style'

const HomePage = () => {
  const classes = useClasses(style)
  return (
    <Box>
      <Grid
        container
        className={classes.container}
        justifyContent="center"
        alignItems="center"
      >
        <ResponsiveAppBar />

        {/* <Grid item lg={6} md={8} xs={12}>
          <Box className={classes.ecoSystem}>
            <img src={EcoSystem} alt=""></img>
          </Box>
        </Grid> */}
      </Grid>
    </Box>
  )
}

export default HomePage
